//
import { MainLayout } from "@/components/reusable_components/next"
import { Welcome } from '@/views'

//
import CommissionsMenu from './menus/commissions'
import CustomersMenu from './menus/customers'
import FamiliesMenu from './menus/families'
import OffersMenu from './menus/offers'
import ProductsMenu from './menus/products'
import PromosMenu from './menus/promos'
import TagsMenu from './menus/tags'
import UsersMenu from './menus/users'
import ReportRoutes from './menus/reports'
import SaleTickets from './menus/tickets'

//
import SlGroundSellerSaleCommissionRoutes from '@/routes/Sale/SlGroundSellerSaleCommission'
import WhPackRoutes from '@/routes/Warehouse/WhPack'

//
export default [
    {
        path: "/",
        component: MainLayout,
        children: [
            {
                /**
                 *  Vista de inicio/bienvenida
                 */
                path: '',
                name: 'index',
                component: Welcome,
            },

            /**
             *  Vistas del sub modulo de productos
             */
            ProductsMenu,

            /**
             *  Vistas del sub modulo de comisiones
             */
            CommissionsMenu,

            /**
             * Vistas del sub modulo de clientes
             */
            CustomersMenu,

            /**
             * Vistas del sub modulo de etiquetas
             */
            TagsMenu,

            /**
             * Vistas del sub modulo de familias
             */
            FamiliesMenu,

            /**
             * Vistas del sub modulo de promociones
             */
            PromosMenu,

            /**
             * Vistas del sub modulo de usuarios/vendedores
             */
            UsersMenu,

            /**
             * Vistas del sub modulo de ofertas
             */
            OffersMenu,

            /**
             * Vistas de reportes
             */
            ReportRoutes,

            /**
             * Vistas de Tickets de Venta
             */
            SaleTickets,

            /**
             * Reporte de vendedores en terreno
             */
            SlGroundSellerSaleCommissionRoutes,
            WhPackRoutes,
        ],
        props: {
            breadcrumbsProps: {
                indexText: "Ventas",
            }
        },
    },

]
